export default __webpack_public_path__ + "static/media/enlarge.2451c376.svg";